import React from "react";
import { Tab, Nav, Container, Row, Col } from "react-bootstrap";
import {
  InfoCircle,
  CloudRain,
  Airplane,
  FileEarmarkText,
} from "react-bootstrap-icons";
import "./../../assets/css/TourInformation.css";

const TourInformation = ({packages}) => {
  return (
    <Container className="tour-info-container">
      <Row>
        <Col>
          <div className="tour-info-section">
            <h4 className="tour-info-header">Tour Information</h4>
            <p className="tour-info-subheader">
              Read this to prepare for your tour in the best way!
            </p>

            <Tab.Container id="tour-info-tabs" defaultActiveKey="inclusions">
              <Nav variant="tabs" className="tour-tabs">
                <Nav.Item>
                  <Nav.Link eventKey="inclusions">Tour Inclusions</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="exclusions">Tour Exclusions</Nav.Link>
                </Nav.Item>
             
              </Nav>

              <Tab.Content className="tour-tab-content">
                <Tab.Pane eventKey="inclusions">
                  <div className="tab-content-inner">
                               <div
                               className="highlights-content"
      dangerouslySetInnerHTML={{ __html: packages?.tourIncludes }}
    />
             
                  </div>
                </Tab.Pane>

                <Tab.Pane eventKey="exclusions">
                  <div className="tab-content-inner">
                               <div
                               className="highlights-content"
      dangerouslySetInnerHTML={{ __html: packages?.tourExcludes }}
    />
                    {/* <ul className="info-list exclusion-list">
                      <li>
                        GST of 5% to be paid over and above the tour price
                      </li>
                      <li>
                        Any increase in Airfare, Airport tax, Fuel surcharge and
                        any new taxes introduced and levied by the Government
                      </li>
                      <li>
                        Any upgradation in Airline class or hotel room category
                      </li>
                      <li>Cost of Insurance</li>
                      <li>Cost of Pre/Post tour hotel accommodation</li>
                      <li>
                        Any extra expense such as route change, Airline change,
                        Date change, Accommodation facilities, etc incurred due
                        to the unforeseen, unavoidable forced majeure
                        circumstances during the tour
                      </li>
                      <li>
                        Porterage (coolie charges), laundry, telephone charges,
                        shopping, wines &amp; alcoholic beverages, mineral
                        water, items of personal nature and food or drink which
                        is not part of a set group menu
                      </li>
                      <li>
                        Any extra cost incurred on behalf of an individual due
                        to illness, accident, hospitalization, or any personal
                        emergency
                      </li>
                      <li>
                        Any services or activity charges other than those
                        included in the group tour itinerary
                      </li>
                      <li>
                        Anything specifically not mentioned in the 'tour price
                        includes' column
                      </li>
                    </ul> */}
                  </div>
                </Tab.Pane>

            
              </Tab.Content>
            </Tab.Container>

            <div className="need-to-know-section">
              <h5 className="need-to-know-header">
                <InfoCircle className="info-icon" /> Need to Know
              </h5>
              <p className="need-to-know-subheader">
                Things to consider before the trip!
              </p>

              <ul className="need-to-know-list">
                <li>
                  <div className="need-to-know-item">
                    <h6 className="item-title">Weather</h6>
                    <div className="item-content">
                      <CloudRain className="item-icon" />
                      <p>
                        For detailed information about weather kindly visit{" "}
                        <a
                          href="http://www.accuweather.com"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          www.accuweather.com
                        </a>
                      </p>
                    </div>
                  </div>
                </li>

                {/* <li>
                  <div className="need-to-know-item">
                    <h6 className="item-title">Transport</h6>
                    <div className="item-content">
                      <Airplane className="item-icon" />
                      <div>
                        <p className="transport-subtitle">Air Travel:</p>
                        <p className="transport-detail">
                          Mumbai – Srinagar / Srinagar – Mumbai
                        </p>
                        <p className="transport-detail">
                          We use Air India / Indigo Airlines
                        </p>
                        <p className="transport-subtitle">Coach Travel:</p>
                        <p className="transport-detail">
                          AC Vehicle Type – Depends upon group size
                        </p>
                      </div>
                    </div>
                  </div>
                </li> */}

                <li>
                  <div className="need-to-know-item">
                    <h6 className="item-title">
                      Documents Required for Travel
                    </h6>
                    <div className="item-content">
                      <FileEarmarkText className="item-icon" />
                      <div>
                        <p className="document-detail">
                          <span>ADULT:</span> Voters ID / Passport / Aadhar Card
                          / Driving Licence
                        </p>
                        <p className="document-detail">
                          <span>CHILD:</span> Passport / Aadhar Card / School ID
                        </p>
                        <p className="document-detail">
                          <span>INFANT:</span> Aadhar Card / Birth certificate
                        </p>
                        <p className="document-note">
                          ID card, ID card type and ID card number is mandatory
                          at time of booking, kindly carry the same ID card on
                          tour.
                        </p>
                        <p className="document-note">
                          For NRI and Foreign National Guests alongwith
                          Passport, Valid Indian Visa / OCI Card / PIO Card is
                          mandatory.
                        </p>
                        <p className="document-note">
                          Carry two passport size photographs.
                        </p>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default TourInformation;
